"use client";

import { JSX, useMemo, useState } from "react";
import RoomCard from "../room-card/RoomCard";

export type Tag = { id: number; title: string; slug: string };
export type RoomWithTags = any & { tag?: Tag | null; tags?: Tag[] | null };

export function RoomsGridClient({
  rooms,
  tags,
}: {
  rooms: RoomWithTags[];
  tags: Tag[];
}) {
  const [active, setActive] = useState<string>("");

  const filtered = useMemo(() => {
    if (!active) return rooms;
    return rooms.filter((r) => {
      const single = r?.tag?.slug === active;
      const many =
        Array.isArray(r?.tags) && r.tags.some((t: any) => t?.slug === active);
      return single || many;
    });
  }, [rooms, active]);

  return (
    <section
      className="max-w-7xl reveal-stagger mx-auto relative py-12 flex flex-col gap-20"
      aria-label="Filter and rooms"
    >
      <ul
        className="flex flex-row gap-6 text-sm text-gray-400 uppercase"
      >
        <li>
          <button
            type="button"
            onClick={() => setActive("")}
            aria-pressed={active === ""}
            className={
              active === ""
                ? "text-black underline reveal-item"
                : "hover:text-black reveal-item cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
            }
          >
            All
          </button>
        </li>
        {tags.map((t) => (
          <li key={t.slug}>
            <button
              type="button"
              onClick={() => setActive(t.slug)}
              aria-pressed={active === t.slug}
              className={
                active === t.slug
                  ? "text-black reveal-item underline"
                  : "hover:text-black reveal-item cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
              }
            >
              {t.title}
            </button>
          </li>
        ))}
      </ul>

      <div className="flex flex-col gap-20">
        {filtered.length === 0 ? (
          <p className="text-lg text-gray-600 reveal-item">
            No rooms available.
          </p>
        ) : (
          filtered.reduce<JSX.Element[]>((rows, room, idx) => {
            if (idx % 2 === 0) {
              const left: any = room;
              const right: any = filtered[idx + 1];
              rows.push(
                <div
                  key={left.id}
                  className="flex reveal-item sm:flex-row sm:flex-nowrap flex-wrap xl:gap-36 md:gap-24 gap-8 max-w-5xl mx-auto w-full"
                >
                  <RoomCard room={left} tallOffset />
                  {right ? (
                    <RoomCard room={right} tallOffset={false} />
                  ) : (
                    <div className="md:w-1/2 w-full" />
                  )}
                </div>,
              );
            }
            return rows;
          }, [])
        )}
      </div>
    </section>
  );
}
